import { lazy, Suspense } from 'react';
import type { PanelInstance } from '@store/Quote/Quote.types';

export interface QuotePanelInstanceProps {
  quoteId: string;
  disabled: boolean;
  panelInstance: PanelInstance;
  level: number;
  isBindQuotePanel?: boolean;
}

const LazyInnerQuotePanelInstance = lazy(() =>
  import('./QuotePanelInstance').then((m) => ({ default: m.QuotePanelInstance })),
);

export const QuotePanelInstance = (props: QuotePanelInstanceProps) => (
  <Suspense fallback={null}>
    <LazyInnerQuotePanelInstance {...props} />
  </Suspense>
);

export default QuotePanelInstance;
